// 埋点 模块类型
export const TRACK_MODULE_TYPE = {
  // 1 纪要
  SUMMARY: {
    value: 1,
    child: {
      // 筛选组件 纪要筛选组件关键字搜索
      SEARCH: { value: 2 },
      // 筛选组件 点击筛选项
      FILTER: { value: 4 },
      // 筛选组件 远程搜索机构
      SEARCH_ORG: { value: 5 },
      // 筛选组件 创建组合
      CREATE_COMBINATION: { value: 6 },
      // 筛选组件 点击已保存组合
      CLICK_SAVED_COMBINATION: { value: 7 },
      // 筛选组件 删除已选的筛选条件（清空）
      DELETE_FILTER: { value: 10 },

      // 列表页点击纪要标题
      SUMMARY_TITLE: { value: 1 },
      // 纪要列表 brm帮你看 按钮
      BRM_AI_BTN: { value: 8 },
      // 纪要列表点击个股标签
      CLICK_STOCK_TAG: { value: 9 },
      // 点击热门纪要标题
      HOT_SUMMARY_TITLE: { value: 11 },
      // 个股关注
      CLICK_FOLLOW: { value: 12 }
    }
  },
  // 2 研报
  RESEARCH_REPORT: {
    value: 2
  },
  // 日程
  SCHEDULE: {
    value: 3,
    child: {
      // tab 我的
      MY: {
        value: 1,
        child: {
          // 新建沟通点击
          NEW_COMMUNICATION: { value: 1 },
          // 日视图点击
          DAY_VIEW: { value: 2 },
          // 周视图点击
          WEEK_VIEW: { value: 3 },
          // 月视图点击
          MONTH_VIEW: { value: 4 },
          // 申请回放按钮点击
          APPLY_PLAYBACK: { value: 5 },
          // 日程标题点击 - 路演会议
          ROADSHOW_TITLE: { value: 6 },
          // 日程-路演会议 - 看详情
          ROADSHOW_DETAIL: { value: 7 },
          // 日程 - 调研活动 - 看详情
          RESEARCH_DETAIL: { value: 8 },
          // 日程 - 线下调研、约访事项、其他事项 - 看详情
          OTHER_DETAIL: { value: 9 },
          // 列表页点击纪要按钮 跳完详情页
          CLICK_SUMMARY: { value: 10 },
          // 日期筛选组件点击（周日期组件）
          DATE_FILTER: { value: 11 },
          // 关键词搜索
          SEARCH: { value: 12 },
          // 展示详情卡片
          SHOW_DETAIL_CARD: { value: 13 },
          // 月视图 右侧抽屉 点击预约
          APPOINTMENT: { value: 14 },
          // 详情卡片点击收藏
          DETAIL_CARD_COLLECT: { value: 15 },
          // 详情卡片点击标记重要
          DETAIL_CARD_IMPORTANT: { value: 16 },
          // 日期组件点击
          DATE_COMPONENT: { value: 17 }
        }
      },
      // tab 我司
      OUR: {
        value: 2,
        child: {
          // 筛选组件 纪要筛选组件关键字搜索
          SEARCH: { value: 1 },
          // 筛选组件 点击筛选项
          FILTER: { value: 2 },
          // 筛选组件 远程搜索机构
          SEARCH_ORG: { value: 3 },
          // 筛选组件 创建组合
          CREATE_COMBINATION: { value: 4 },
          // 筛选组件 点击已保存组合
          CLICK_SAVED_COMBINATION: { value: 5 },
          // 筛选组件 删除已选的筛选条件（清空）
          DELETE_FILTER: { value: 6 },
          // 预约按钮点击
          APPOINTMENT: { value: 7 },
          // 路演会议列表路演点击次数
          ROADSHOW_TITLE: { value: 8 },
          // 日期筛选组件点击（周日期组件）
          DATE_FILTER: { value: 9 },
          // 收藏
          CLICK_COLLECT: { value: 10 },
          // 点击更多icon
          CLICK_MORE_ICON: { value: 11 },
          // 日期组件点击
          DATE_COMPONENT: { value: 12 }
        }
      },
      // tab 市场
      MARKET: {
        value: 3,
        child: {
          // 筛选组件 纪要筛选组件关键字搜索
          SEARCH: { value: 1 },
          // 筛选组件 点击筛选项
          FILTER: { value: 2 },
          // 筛选组件 远程搜索机构
          SEARCH_ORG: { value: 3 },
          // 筛选组件 创建组合
          CREATE_COMBINATION: { value: 4 },
          // 筛选组件 点击已保存组合
          CLICK_SAVED_COMBINATION: { value: 5 },
          // 筛选组件 删除已选的筛选条件（清空）
          DELETE_FILTER: { value: 6 },
          // 预约按钮点击
          APPOINTMENT: { value: 7 },
          // 市场列表路演点击次数
          ROADSHOW_TITLE: { value: 8 },
          // 日期筛选组件点击（周日期组件）
          DATE_FILTER: { value: 9 },
          // 收藏
          CLICK_COLLECT: { value: 10 },
          // 点击更多icon
          CLICK_MORE_ICON: { value: 11 },
          // 日期组件点击
          DATE_COMPONENT: { value: 12 }
        }
      }
    }
  },
  // 会议
  MEETING: {
    value: 4,
    child: {
      // 历史会议按钮
      HISTORY_MEETING: { value: 1 }
    }
  },
  // 市场
  MARKET: {
    value: 5,
    child: {
      // 统计路演快捷入口点击量
      CLICK_ROADSHOW: { value: 1 },
      // 统计纪要快捷入口点击量
      CLICK_SUMMARY: { value: 2 },
      // 统计调研快捷入口点击量
      CLICK_RESEARCH: { value: 3 },
      // 统计研报快捷入口点击量
      CLICK_RESEARCH_REPORT: { value: 4 },
      // 统计问答快捷入口点击量
      CLICK_QUESTION_ANSWER: { value: 5 },
      // 推荐关注-用户点击关注数据量
      CLICK_FOLLOW: { value: 6 },
      // 推荐关注-统计用户在我的关注页面访问上市公司主页的数据量
      CLICK_COMPANY_HOME: { value: 7 },
      // 内容展示-统计用户在推荐/我的关注菜单，点击查看“路演”详情
      CLICK_ROADSHOW_DETAIL: { value: 8 },
      // 内容展示-统计用户在推荐/我的关注单，点击查看“纪要”详情
      CLICK_SUMMARY_DETAIL: { value: 9 },
      // 内容展示-统计用户在推荐/我的关注菜单，点击查看“调研”详情
      CLICK_RESEARCH_DETAIL: { value: 10 },
      // 内容展示-统计用户在推荐/我的关注菜单，点击查看“研报”详情
      CLICK_RESEARCH_REPORT_DETAIL: { value: 11 },
      // 内容展示-统计用户在推荐/我的关注菜单，点击查看“问答”详情
      CLICK_QUESTION_ANSWER_DETAIL: { value: 12 },
      // 我的关注-统计用户在我的关注页面，点击查看“上市公司”主页数据
      CLICK_MY_COMPANY_HOME: { value: 13 },
      // 市场风向-统计用户点击“筛选”按钮及查看行业的数据
      CLICK_FILTER: { value: 14 },
      // 纪要 tab
      SUMMARY: {
        value: 15,
        child: {
          // 纪要个股点击后 关注按钮点击
          SUMMARY_FOLLOW: { value: 1 }
        }
      },
      // 问答 tab
      QUESTION: {
        value: 16,
        child: {
          // 问答个股点击后 关注按钮点击
          QUESTION_FOLLOW: { value: 1 }
        }
      },
      // 路演 tab
      ROADSHOW: {
        value: 17,
        child: {
          // 路演个股点击后 关注按钮点击
          ROADSHOW_FOLLOW: { value: 1 }
        }
      },
      // 研报 tab
      RESEARCH_REPORT: {
        value: 18,
        child: {
          // 研报个股点击后 关注按钮点击
          RESEARCH_REPORT_FOLLOW: { value: 1 }
        }
      }
    }
  },
  // 问答
  QUESTION: {
    value: 6,
    child: {
      // 个股关注
      CLICK_FOLLOW: { value: 1 },
      // 问答标题点击
      QUESTION_TITLE: { value: 2 }
    }
  },
  // 全局搜索
  GLOBAL_SEARCH: {
    value: 7,
    child: {
      // 综合
      INTEGRATED: {
        value: 1,
        child: {
          // 纪要个股点击后 关注按钮点击
          SUMMARY_FOLLOW: { value: 1 },
          // 问答个股点击后 关注按钮点击
          QUESTION_FOLLOW: { value: 2 },
          // 上市公司点击详情后点击关注按钮
          COMPANY_FOLLOW: { value: 3 },
          // 研报个股点击后 关注按钮点击
          RESEARCH_REPORT_FOLLOW: { value: 4 },
          // 路演点击
          ROADSHOW: { value: 5 },
          // 纪要点击
          SUMMARY: { value: 6 },
          // 纪要个股点击
          SUMMARY_STOCK: { value: 7 },
          // 研报点击
          RESEARCH_REPORT: { value: 8 },
          // 问答点击
          QUESTION: { value: 9 },
          // 问答个股点击
          QUESTION_STOCK: { value: 10 },
          // 研报个股点击
          RESEARCH_REPORT_STOCK: { value: 11 },
          // 点击上市公司
          COMPANY: { value: 12 },
          // 会议点击详情
          MEETING: { value: 13 },
          // 智能搜索 搜索
          AI_SEARCH: { value: 14 },
          // 智能搜索 搜索再试一次
          AI_SEARCH_AGAIN: { value: 15 },
          // 智能搜索 复制
          AI_COPY: { value: 16 },
          // 智能搜索 点赞
          AI_LIKE: { value: 17 },
          // 智能搜索 点踩
          AI_DISLIKE: { value: 18 }
        }
      },
      // 纪要
      SUMMARY: {
        value: 2,
        child: {
          // 纪要个股点击后 关注按钮点击
          SUMMARY_FOLLOW: { value: 1 },
          // 标题点击
          SUMMARY_TITLE: { value: 2 }
        }
      },
      // 研报
      RESEARCH_REPORT: {
        value: 3,
        child: {
          // 研报个股点击后 关注按钮点击
          RESEARCH_REPORT_FOLLOW: { value: 1 },
          // 标题点击
          RESEARCH_REPORT_TITLE: { value: 2 },
          // 研报点击个股标签
          CLICK_STOCK_TAG: { value: 3 }
        }
      },
      // 问答
      QUESTION: {
        value: 4,
        child: {
          // 问答个股点击后 关注按钮点击
          QUESTION_FOLLOW: { value: 1 },
          // 标题点击
          QUESTION_TITLE: { value: 2 },
          // 问答点击个股标签
          CLICK_STOCK_TAG: { value: 3 }
        }
      },
      // 上市公司
      COMPANY: {
        value: 5,
        child: {
          // 上市公司个股点击后 关注按钮点击
          COMPANY_FOLLOW: { value: 1 },
          // 上市公司点击
          CLICK_COMPANY: { value: 2 }
        }
      },
      // 路演
      ROADSHOW: {
        value: 6,
        child: {
          // 路演点击
          CLICK_ROADSHOW: { value: 1 }
        }
      },
      // 日程
      SCHEDULE: {
        value: 7,
        child: {
          // 点击日程
          CLICK_SCHEDULE: { value: 1 }
        }
      },
      // 会议
      MEETING: {
        value: 8,
        child: {
          // 点击会议
          CLICK_MEETING: { value: 1 }
        }
      }
    }
  },
  // 个人中心
  PERSONAL_CENTER: {
    value: 8,
    child: {
      // 我的关注
      MY_FOLLOW: {
        value: 1,
        child: {
          // 查看上市公司
          CLICK_COMPANY: { value: 1 },
          // 上市公司点击详情后点击关注按钮
          COMPANY_FOLLOW: { value: 2 }
        }
      },
      // 我的收藏
      MY_COLLECTION: {
        value: 2,
        child: {
          // 查看路演详情
          ROADSHOW_DETAIL: { value: 1 },
          // 查看纪要详情
          SUMMARY_DETAIL: { value: 2 },
          // 查看研报详情
          REPORT_DETAIL: { value: 3 }
        }
      },
      // 历史记录
      MY_HISTORY: {
        value: 3,
        child: {
          // 查看路演详情
          ROADSHOW_DETAIL: { value: 1 },
          // 查看纪要详情
          SUMMARY_DETAIL: { value: 2 },
          // 查看研报详情
          REPORT_DETAIL: { value: 3 }
        }
      }
    }
  },
  // 全局菜单
  GLOBAL_MENU: {
    value: 14,
    child: {
      // 快捷操作
      QUICK_ACTIONS: {
        value: 1,
        child: {
          // 收藏
          CLICK_COLLECT: { value: 1 },
          // 我的收藏
          MY_COLLECTION: { value: 2 },
          // 历史记录
          MY_HISTORY: { value: 3 }
        }
      }
    }
  },
  // 调研
  SURVEY: {
    value: 9,
    child: {
      // 策略会
      SELECT: {
        value: 1,
        child: {
          // 筛选组件 点击筛选项
          FILTER: { value: 2 },
          // 筛选组件 远程搜索机构
          SEARCH_ORG: { value: 3 },
          // 筛选组件 创建组合
          CREATE_COMBINATION: { value: 4 },
          // 筛选组件 点击已保存组合
          CLICK_SAVED_COMBINATION: { value: 5 },
          // 筛选组件 删除已选的筛选条件（清空）
          DELETE_FILTER: { value: 6 },
          // 策略会标题点击（区分列表/热门/相关推荐）
          STRATEGY_TITLE: { value: 7 },
          // 策略会 搜索标题
          SEARCH_TITLE: { value: 8 }
        }
      },
      // 调研活动
      SURVEY: {
        value: 2,
        child: {
          // 筛选组件 点击筛选项
          FILTER: { value: 2 },
          // 筛选组件 远程搜索机构
          SEARCH_ORG: { value: 3 },
          // 筛选组件 创建组合
          CREATE_COMBINATION: { value: 4 },
          // 筛选组件 点击已保存组合
          CLICK_SAVED_COMBINATION: { value: 5 },
          // 筛选组件 删除已选的筛选条件（清空）
          DELETE_FILTER: { value: 6 },
          // 调研活动标题点击（区分列表/热门/相关推荐）
          SURVEY_TITLE: { value: 7 },
          // 调研活动 搜索标题
          SEARCH_TITLE: { value: 8 }
        }
      }
    }
  },
  // 登录
  LOGIN: {
    value: 10,
    BTN: {
      value: 1
    }
  },
  // 通讯录
  ADDRESS_BOOK: {
    value: 11,
    child: {
      // 内部联系人
      INTERNAL_CONTACT: {
        value: 1
      },
      // 券商研究所
      BROKERAGE_RE: {
        value: 2
      }
    }
  },
  // 发现
  DISCOVER: {
    value: 12
  },
  // 企业管理
  ENTERPRISE_MANAGE: {
    value: 13,
    child: {
      // 成员管理
      MEMBER_MANAGE: {
        value: 1
      },
      // 机构设置
      ORG_SETTING: {
        value: 2
      },
      // 合作权益
      COOPERATION: {
        value: 3
      },
      // 合作券商
      COOPERATION_BROKERAGE: {
        value: 4
      },
      // 数据统计
      DATA_STATISTICS: {
        value: 5
      }
    }
  },
  // 自选
  SELFSELECTED: {
    value: 15,
    child: {
      // 个股
      STOCK: {
        value: 1,
        child: {
          // 概览-一级行业名称
          OVERVIEW_INDUSTRY: { value: 1 },
          // 概览-关联主题名称
          OVERVIEW_THEME: { value: 2 },
          // 概览-相对一级行业热度更多
          OVERVIEW_HOTMORE: { value: 3 },
          // 研究复盘-日线，周线，月线
          RESEARCH_CHARTDATE: { value: 4 },
          // 研究复盘-前复权
          RESEARCH_REHABILITATION: { value: 5 },
          // 研究复盘-业绩公告、重大公告、路演、调研、深度研报
          RESEARCH_DATATYPE: { value: 6 },
          // 研究复盘-叠加指标：归母净利润同比增速，营业收入同比增速，PE-TTM，PB，MA5, MA20、
          RESEARCH_LINETYPE: { value: 7 },
          // 研究复盘-分钟K线（1分/5分/15分/30分/1H）
          RESEARCH_MINUTE_KLINE: { value: 15 },
          // 研究复盘-分时线
          RESEARCH_TIME_SHARE: { value: 16 }
        }
      }
    }
  },
  // 会员专区
  MEMBER_ZONE: {
    value: '024',
    child: {
      // 会员专区主功能
      MAIN: {
        value: 1,
        child: {
          // 024-1-1 进入会员专区页面
          PAGE_VIEW: { value: 1 },
          // 024-1-2 续费/购买按钮点击
          RENEW_PURCHASE: { value: 2 },
          // 024-1-3 全部权益按钮点击
          ALL_BENEFITS: { value: 3 },
          // 024-1-4 具体权益点击
          BENEFIT_ITEM: { value: 4 },
          // 024-1-5 尊享内容tab点击
          EXCLUSIVE_TAB: { value: 5 },
          // 024-1-6 尊享内容 - 路演点击
          EXCLUSIVE_ROADSHOW: { value: 6 },
          // 024-1-7 尊享内容 - 调研点击
          EXCLUSIVE_SURVEY: { value: 7 },
          // 024-1-8 尊享内容 - 内资研报点击
          EXCLUSIVE_REPORT: { value: 8 },
          // 024-1-9 尊享内容 - 会议纪要点击
          EXCLUSIVE_MEETING_SUMMARY: { value: 9 },
          // 024-1-10 尊享内容 - 调研纪要点击
          EXCLUSIVE_SURVEY_SUMMARY: { value: 10 },
          // 024-1-11 尊享内容 - 外资研报点击
          EXCLUSIVE_FOREIGN_REPORT: { value: 11 },
          // 024-1-12 尊享内容 - 专享点评点击
          EXCLUSIVE_COMMENT: { value: 12 },
          // 024-1-13 专属推荐内容点击
          RECOMMEND_ITEM: { value: 13 },
          // 024-1-14 已兑换内容tab点击
          EXCHANGED_TAB: { value: 14 },
          // 024-1-15 已兑换内容 - 路演点击
          EXCHANGED_ROADSHOW: { value: 15 },
          // 024-1-16 已兑换内容 - 调研点击
          EXCHANGED_SURVEY: { value: 16 },
          // 024-1-17 已兑换内容 - 内资研报点击
          EXCHANGED_REPORT: { value: 17 },
          // 024-1-18 已兑换内容 - 点评点击
          EXCHANGED_COMMENT: { value: 18 },
          // 024-1-19 已兑换内容 - 调研纪要点击
          EXCHANGED_SURVEY_SUMMARY: { value: 19 }
        }
      }
    }
  }
};

// 埋点事件类型
export const TRACK_EVENT_TYPE = {
  // 点击
  CLICK: 1,
  // 搜索
  SEARCH: 2,
  // 浏览
  BROWSE: 3,
  // 筛选
  FILTER: 4,
  // 创建
  CREATE: 5
};
